import { render, staticRenderFns } from "./logisticsIndex.vue?vue&type=template&id=7b632c1d&"
import script from "./logisticsIndex.vue?vue&type=script&lang=js&"
export * from "./logisticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports